import { styled } from 'src/styles/stitches.config';

export const StyledGlobalScroller = styled('div', {
	height: '100vh',
	'.scrollbar-track': {
		zIndex: 111,
	},
});
